// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__A9Ilm","title":"ClientReferral_title__3en9J","itemText":"ClientReferral_itemText__3Lw_z"};